export default __webpack_public_path__ + "static/media/withdrawalSuccess.c7bd822a.png";